import { generateMedia } from 'styled-media-query'

const customMedia = generateMedia({
  desktop: '64.063em',
  tablet: '64em',
  mobile: '40em',
})

export default customMedia
